import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Credential is an abstract class for Azure Storage HTTP requests signing. This
 * class will host an credentialPolicyCreator factory which generates CredentialPolicy.
 */
export var Credential = /*#__PURE__*/function () {
  function Credential() {
    _classCallCheck(this, Credential);
  }

  _createClass(Credential, [{
    key: "create",
    value:
    /**
     * Creates a RequestPolicy object.
     *
     * @param _nextPolicy -
     * @param _options -
     */
    function create(_nextPolicy, _options) {
      throw new Error("Method should be implemented in children classes.");
    }
  }]);

  return Credential;
}();